// Types matching backend DTOs
export interface RaceTypeSummary {
  id: number;
  name: string;
  distance: number;
  price: number;
  packageType?: string;
  startNumber: number;
  endNumber: number;
  maxBibNumber: number;
  maxParticipants: number;
  numberOfZones?: number;
  raceId: string;
}

export interface RaceData {
  id: string;
  name: string;
  description?: string;
  status: string;
  location?: string;
  startDate: string;
  openRegistrationDate?: string;
  closeRegistrationDate?: string;
  imageUrl?: string;
  category?: string;
  raceTypes: RaceTypeSummary[];
}

export interface RegistrationFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  country: string;
  gender: string;
  dateOfBirth: string;
  raceId: string | '';
  raceTypeId: number | '';
  participantType: 'Individual' | 'Team';
  teamName?: string;
  tshirtSize: string;
  discountCode?: string;
  emergencyContactPhone?: string;
  cookiesConsent: boolean;
  privacyPolicy: boolean;
}

export interface RegistrationFormProps {
  values: RegistrationFormValues;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  submitting: boolean;
  error?: string;
  races: RaceData[];
  racesLoading: boolean;
  selectedRace: RaceData | null;
  raceTypes: RaceTypeSummary[];
  registrationOpen: boolean;
  tshirtSizes?: string[];
}

export const initialFormValues: RegistrationFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  city: '',
  country: '',
  gender: '',
  dateOfBirth: '',
  raceId: '',
  raceTypeId: '',
  participantType: 'Individual',
  teamName: '',
  tshirtSize: 'M',
  discountCode: '',
  emergencyContactPhone: '',
  cookiesConsent: false,
  privacyPolicy: false,
};
